// prettier-ignore
import { lazy } from 'react';
import { RouteProps } from './types';

const LoginContainer = lazy(
    () => import('../apps/phio/containers/LoginContainer/LoginContainer'),
);
const NotFound = lazy(() => import('../apps/phio/containers/NotFound'));
const NoConsent = lazy(() => import('../apps/phio/containers/NoConsent'));
const CallBackContainer = lazy(
    () => import('../apps/phio/containers/CallBackContainer/CallBackContainer'),
);
const EmailSignInContainer = lazy(
    () =>
        import(
            '../apps/phio/containers/EmailSignInContainer/EmailSignInContainer'
        ),
);
const TriageEndedContainer = lazy(
    () => import('../apps/phio/containers/TriageEndedContainer'),
);
const Logout = lazy(() => import('../apps/phio/containers/Logout'));
const Timeout = lazy(() => import('../apps/phio/containers/Timeout'));
const OptOut = lazy(() => import('../apps/phio/containers/TriageOptOut'));

const loginRoutes: RouteProps[] = [
    {
        path: 'triageended/:clientName',
        element: <TriageEndedContainer />,
        routeName: 'TriageEnded',
    },
    {
        path: 'triageoptout',
        element: <OptOut />,
        routeName: 'TriageOptOut',
    },
    {
        path: 'emailSignIn',
        element: <EmailSignInContainer />,
        routeName: 'EmailSignIn',
    },
    {
        path: 'callback',
        element: <CallBackContainer />,
        routeName: 'callback',
    },
    {
        path: 'noconsent',
        element: <NoConsent />,
        routeName: 'noconsent',
    },
    {
        path: 'notfound',
        element: <NotFound />,
        routeName: 'Notfound',
    },
    { path: 'timeout', element: <Timeout />, routeName: 'Timeout' },
    { path: 'logout', element: <Logout />, routeName: 'Logout' },
    {
        path: '',
        element: <LoginContainer />,
        routeName: 'Login',
    },
];

export default loginRoutes;
